module.exports = __webpack_public_path__ + "img/7b05a96d3674db90170185f724bc0026.png";